import PanierI18n from './Panier.i18n.js';
import {
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex'
export default {

  components: {},
  computed: {
    ...mapGetters(['cart', 'user'])
  },
  props: {},

  data() {
    return {
      total: 0,
      totalWithReduc: 0
    };
  },

  watch: {
    cart() {
      this.cart.forEach(item => {
        this.setTotalProductPrice(item)
      })
      this.getTotal()
      //this.getTotalWithReduc()
    }
  },

  methods: {
    ...mapMutations(['deleteFromCart', 'setTotalProductPrice']),
    /**
     * Remove item from cart.
     * @param {*} pProduct 
     */
    revoveProduct(pProduct) {
      this.deleteFromCart(pProduct)
    },
    /**
     * Set the price of the product line.
     * @param {*} pQuantity 
     * @param {*} pPrice 
     */
    getTotal() {
      this.total = 0
      this.cart.forEach(item => {
        this.total = this.total + this.prixCalcule(item)
      })
    },
    getTotalWithReduc() {
      this.totalWithReduc = 0
      this.cart.forEach(item => {
        this.totalWithReduc = this.totalWithReduc + this.prixCalcule(item)
      })
    },
    /**
     * Update the price of product line.
     * @param {*} pProduct 
     */
    setProductPriceLine(pProduct) {
      this.setTotalProductPrice(pProduct)
      this.getTotal()
      //this.$forceUpdate()
    },
    goToOrder() {
      this.$router.push({
        path: `/commande`
      })
    },

    goToLogin() {
      localStorage.setItem('isFromCart', true)
      this.$router.push({
        path: `/login`
      })
    },

    goToHome() {
      this.$router.push({
        path: `/`
      })
    },
    /**
     * Calcul du prix avec la réduction.
     * @returns 
     */
    prixCalcule(pArticle) {
      return pArticle.totalProductPrice * (1 - pArticle.reduction / 100).toFixed(2)
    },
  },

  filters: {
    currency: (value) => {
      const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    }
  },

  mounted() {
    window.scrollTo(0, 0)
    this.cart.forEach(item => {
      this.setTotalProductPrice(item)
    })
    this.getTotal()
    this.getTotalWithReduc()
  },

  i18n: PanierI18n,

};